import { useEffect, useState } from 'react';

/**
 * Returns the current unix-seconds wall-clock, ticking at the given cadence.
 * Pauses when the tab is hidden so we don't wake the device for nothing.
 *
 * @param {number} [intervalMs=500]
 * @returns {number} unix seconds (float)
 */
export function useNowTick(intervalMs = 500) {
  const [now, setNow] = useState(() => Date.now() / 1000);

  useEffect(() => {
    let id = null;
    const tick = () => setNow(Date.now() / 1000);
    const start = () => {
      if (id != null) return;
      id = window.setInterval(tick, intervalMs);
    };
    const stop = () => {
      if (id != null) {
        window.clearInterval(id);
        id = null;
      }
    };
    if (document.visibilityState === 'visible') start();
    const onVis = () => {
      if (document.visibilityState === 'visible') {
        tick();
        start();
      } else {
        stop();
      }
    };
    document.addEventListener('visibilitychange', onVis);
    return () => {
      stop();
      document.removeEventListener('visibilitychange', onVis);
    };
  }, [intervalMs]);

  return now;
}
